import { Component, OnInit } from '@angular/core';
import { SpinnerService } from '@core/services/spinner/spinner.service';

@Component({
	selector: 'romeo-spinner',
	templateUrl: './spinner.component.html',
	styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit {
	show!: boolean;
	constructor(private spinner: SpinnerService) { }

	ngOnInit(): void {
		this.spinner.spinner.subscribe( data => {
    
			this.show = data;
		   
		  })
	  
	}

}
